<script>
export default {
	inject: ['manager'],
	props: {
		tagClass: String,
	},
}
</script>

<template>
	<div
		v-if="manager.tags && manager.tags.length"
		:class="[
			'product-card__tags d-flex flex-column',
			{
				'product-card__tags--desktop': !$b.m,
				'align-baseline': manager.alignment == 'left',
				'align-center': manager.alignment == 'center',
				'align-end': manager.alignment == 'right',
			},
		]"
	>
		<div
			v-for="({ html, style }, n) of manager.tags"
			:key="n"
			class="product-card__tag rounded line-clamp-2 px-1"
			v-html="html"
			:class="tagClass"
			:style="style"
		></div>
	</div>
</template>

<style scoped>
.product-card__tags {
	gap: 6px;
}
</style>

